/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Template_Min_Gap_CancelInputs */

const en_ad_template_min_gap_cancel = /** @type {(inputs: Ad_Template_Min_Gap_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

const fr_ad_template_min_gap_cancel = /** @type {(inputs: Ad_Template_Min_Gap_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler`)
};

const de_ad_template_min_gap_cancel = /** @type {(inputs: Ad_Template_Min_Gap_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abbrechen`)
};

const it_ad_template_min_gap_cancel = /** @type {(inputs: Ad_Template_Min_Gap_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annulla`)
};

const ru_ad_template_min_gap_cancel = /** @type {(inputs: Ad_Template_Min_Gap_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отмена`)
};

const es_ad_template_min_gap_cancel = /** @type {(inputs: Ad_Template_Min_Gap_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar`)
};

const zh_cn2_ad_template_min_gap_cancel = /** @type {(inputs: Ad_Template_Min_Gap_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消`)
};

const ja_ad_template_min_gap_cancel = /** @type {(inputs: Ad_Template_Min_Gap_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャンセル`)
};

const hi_ad_template_min_gap_cancel = /** @type {(inputs: Ad_Template_Min_Gap_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रद्द करें`)
};

const pt_pt2_ad_template_min_gap_cancel = /** @type {(inputs: Ad_Template_Min_Gap_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar`)
};

/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Ad_Template_Min_Gap_CancelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_template_min_gap_cancel = /** @type {((inputs?: Ad_Template_Min_Gap_CancelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Template_Min_Gap_CancelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ad_template_min_gap_cancel(inputs)
	if (locale === "de") return de_ad_template_min_gap_cancel(inputs)
	if (locale === "it") return it_ad_template_min_gap_cancel(inputs)
	if (locale === "ru") return ru_ad_template_min_gap_cancel(inputs)
	if (locale === "es") return es_ad_template_min_gap_cancel(inputs)
	if (locale === "zh-CN") return zh_cn2_ad_template_min_gap_cancel(inputs)
	if (locale === "ja") return ja_ad_template_min_gap_cancel(inputs)
	if (locale === "hi") return hi_ad_template_min_gap_cancel(inputs)
	if (locale === "pt-PT") return pt_pt2_ad_template_min_gap_cancel(inputs)
	return en_ad_template_min_gap_cancel(inputs)
});